'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = require('../../lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'button': 'Secondary__button___183vh',
  'small': 'Secondary__small___1JjIL',
  'medium': 'Secondary__medium___2PQuO',
  'large': 'Secondary__large___eBhCW'
};

var SecondaryButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
SecondaryButton.displayName = 'SecondaryButton';
exports.default = SecondaryButton;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/Button/Secondary.js
// module id = 845
// module chunks = 4 5 8 9 14